import React from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  useTheme,
} from "@mui/material";

export const ContactFormSection = () => {
  const theme = useTheme();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // Lógica de envio do formulário aqui (ex: API call)
    console.log("Formulário enviado!");
    // Adicionar feedback ao usuário (snackbar, mensagem de sucesso, etc.)
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        py: { xs: 8, md: 12 },
      }}
      id="contact"
    >
      <Container maxWidth="md">
        <Typography
          variant="overline"
          align="center"
          display="block"
          gutterBottom
        >
          Contato
        </Typography>
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{ mb: 6, fontWeight: 600, color: theme.palette.text.primary }}
        >
          Fale Conosco
        </Typography>
        <Paper
          elevation={1}
          sx={{ p: { xs: 3, md: 5 }, borderRadius: theme.shape.borderRadius }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="name"
                  label="Seu Nome"
                  name="name"
                  autoComplete="name"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="Seu Email"
                  name="email"
                  type="email"
                  autoComplete="email"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="message"
                  label="Sua Mensagem"
                  name="message"
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="secondary" // Usando a cor secundária para o botão principal do form
                  size="large"
                >
                  Enviar Mensagem
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    </Box>
  );
};
